import _ from 'lodash';
import classNames from 'classnames';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import FontAwesome from 'react-fontawesome';
import * as actions from '../../../actions/regActions';
// import Button from '../../../components/common/Button';
// import { Link } from 'react-router';
import TextInput from '../../../components/common/TextInput';
import * as utils from '../../../components/common/utils';

class ClubInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.altHelper = this.altHelper.bind(this);
    this.toggleSection = this.toggleSection.bind(this);
    this.registeredCheckboxText = this.registeredCheckboxText.bind(this);
    this.state = {
      details: props.details,
      errors: props.errors,
      showAlt: false,
      showBilling: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(nextProps.details, this.props.details)) {
      this.setState({
        details: nextProps.details,
        errors: {},
      });
    }
    if(!_.isEqual(nextProps.errors, this.props.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  toggleSection(section) {
    let updatedState = !this.state[section];
    this.setState({
      [section]: updatedState
    });
  }

  registeredCheckboxText() {
    let currentStatus = this.state.details.archived;
    // let savedStatus = this.props.details.archived;
    let result;
    if (this.state.details.id == undefined) {
      return null;
    } else if (!currentStatus) {
      result = 'Trykk her for å melde av klubben. Klubben er nå registrert som påmeldt.';
    } else if (currentStatus) {
      result = 'OBS! Trykk her for å melde på klubben. Klubben er nå ikke påmeldt.';
    }
    if (this.props.detailsDiff.archived && this.props.detailsDiff.archived[0] != this.state.details.archived) {
      result += ' OBS! Endringen må godkjennes.';
    }
    return result;
  }

  altHelper(field, prefix) {
    prefix = prefix ? prefix : 'alt_';
    if (this.state.details[prefix+field]) {
      return this.state.details[prefix+field];
    } else {
      return this.props.clubDetails['club_' + field];
    }
  }

  render() {
    if (this.props.show == false) {
      return null;
    }
    let clubAddress = utils.join([
      this.altHelper('address'),
      this.altHelper('zip'),
      this.altHelper('municipality'),
      this.altHelper('county'),
      this.altHelper('country')], ", ");
    let billingAddress = utils.join([
      this.altHelper('address', 'billing_'),
      this.altHelper('zip', 'billing_'),
      this.altHelper('municipality', 'billing_'),
      this.altHelper('county', 'billing_'),
      this.altHelper('country', 'billing_')], ", ");
    let registeredCheckboxText = this.registeredCheckboxText();
    let infoDiff = _.omit(this.props.detailsDiff, ['member_registrations', 'teams', 'approved']);
    return (
      <div className="register-event-club-Info">
        <div className={'page-header'}>
          <h2>{'Påmelding - ' + this.props.clubDetails.name}</h2>
        </div>
        {!_.isEmpty(infoDiff) && <div className="panel panel-warning">
          <div className="panel-heading">
            <FontAwesome name="warning" />
            &nbsp;
            Endringer som venter på godkjenning
          </div>
          <div className="panel-body">
            Felter med advarselstegn merket i gult er endret.
          </div>
        </div>}
        <div className="row">
          {registeredCheckboxText && <div className="col-sm-12 clearfix">
            <label htmlFor={'archived'} className="center-block">
              <div className={classNames('alert', {
                  'alert-danger': this.state.details.archived,
                  'alert-success': !this.state.details.archived,
                  'alert-warning alert-striped-warning': (
                    this.props.detailsDiff.archived &&
                    this.props.detailsDiff.archived[0] != this.state.details.archived),
                })}>
                  <input type="checkbox"
                    name={'archived'}
                    id={'archived'}
                    onChange={this.props.updateReverseBooleanField}
                    checked={!this.state.details.archived}
                    value={'archived'}
                     />
                   {'  '}
                   {registeredCheckboxText}
               </div>
            </label>
          </div>}
          <div className="col-sm-6">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h4>{'Kontaktperson'}</h4>
              </div>
              <div className="panel-body club-info-box">
              <div className="">
                <strong>Navn:</strong>
                <p>{this.altHelper('contact_person')}</p>
                <strong>Epost:</strong>
                <p>{this.altHelper('contact_email')}</p>
                <strong>Tlf:</strong>
                <p>{this.altHelper('contact_phone_number')}</p>
                <strong>Adresse:</strong>
                <p>{clubAddress}</p>
              </div>
              <div>
                <div className="page-header">
                  <h4>
                    Endre kontaktperson
                  </h4>
                </div>
                <TextInput
                  label="Navn"
                  diffObject={this.props.detailsDiff}
                  error={this.state.errors.alt_contact_person}
                  name="alt_contact_person"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_contact_person}
                  />
                <TextInput
                  label="Epost"
                  diffObject={this.props.detailsDiff}
                  error={this.state.errors.alt_contact_email}
                  name="alt_contact_email"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_contact_email}
                  />
                <TextInput
                  label="Telefonnummer"
                  error={this.state.errors.alt_contact_phone_number}
                  diffObject={this.props.detailsDiff}
                  name="alt_contact_phone_number"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_contact_phone_number}
                  />
                <TextInput
                  label="Adresse"
                  error={this.state.errors.alt_address}
                  diffObject={this.props.detailsDiff}
                  name="alt_address"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_address}
                  />
                <TextInput
                  label="Kommune"
                  error={this.state.errors.alt_municipality}
                  diffObject={this.props.detailsDiff}
                  name="alt_municipality"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_municipality}
                  />
                <TextInput
                  label="Fylke"
                  error={this.state.errors.alt_county}
                  diffObject={this.props.detailsDiff}
                  name="alt_county"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_county}
                  />
                <TextInput
                  label="Postnummer"
                  error={this.state.errors.alt_zip}
                  diffObject={this.props.detailsDiff}
                  name="alt_zip"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_zip}
                  />
                <TextInput
                  label="Land"
                  error={this.state.errors.alt_country}
                  diffObject={this.props.detailsDiff}
                  name="alt_country"
                  onChange={this.props.updateField}
                  value={this.state.details.alt_country}
                  />
                </div>
              </div>
            </div>
          </div>
          <br className="visible-xs-block"/>
          <div className="col-sm-6">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h4>{'Fakturaadresse'}</h4>
              </div>
              <div className="panel-body club-info-box">
                <div>
                  <strong>Kontaktperson:</strong>
                  <p>{this.altHelper('contact_person', 'billing_')}</p>
                  <strong>Epost:</strong>
                  <p>{this.altHelper('email', 'billing_')}</p>
                  <strong>Adresse:</strong>
                  <p>{billingAddress}</p>
                </div>
                <div>
                  <div className="page-header">
                    <h4>
                      Endre fakturaadresse
                    </h4>
                  </div>
                  <TextInput
                    label="Navn"
                    error={this.state.errors.billing_contact_person}
                    name="billing_contact_person"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_contact_person}
                    />
                  <TextInput
                    label="Epost"
                    error={this.state.errors.billing_email}
                    name="billing_email"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_email}
                    />
                  <TextInput
                    label="Adresse"
                    error={this.state.errors.billing_address}
                    name="billing_address"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_address}
                    />
                  <TextInput
                    label="Kommune"
                    error={this.state.errors.billing_municipality}
                    name="billing_municipality"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_municipality}
                    />
                  <TextInput
                    label="Fylke"
                    error={this.state.errors.billing_county}
                    name="billing_county"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_county}
                    />
                  <TextInput
                    label="Postnummer"
                    error={this.state.errors.billing_zip}
                    name="billing_zip"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_zip}
                    />
                  <TextInput
                    label="Land"
                    error={this.state.errors.billing_country}
                    name="billing_country"
                    diffObject={this.props.detailsDiff}
                    onChange={this.props.updateField}
                    value={this.state.details.billing_country}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ClubInfo.propTypes = {
  actions: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  detailsDiff: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  eventId: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired,
  detailsUpdated: PropTypes.number,
  errors: PropTypes.object,
  loading: PropTypes.bool,
  show: PropTypes.bool,
  registeredWarning: PropTypes.func,
  updateBooleanField: PropTypes.func,
  updateReverseBooleanField: PropTypes.func,
  updateField: PropTypes.func,
  updateTimeField: PropTypes.func,
  submitForm: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  return {
    loading: state.registration.loading,
    eventDetails: state.events.eventDetails,
    clubDetails: state.clubs.clubDetails,
    eventId: ownProps.eventId,
    clubId: ownProps.clubId,
    detailsUpdated: state.registration.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubInfo);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/ClubInfo.js
 **/